export default __webpack_public_path__ + "static/media/ReCreating EU_logo_neg.679c7528.png";